<template>

  <div>
    <input-keyword
      v-model="keywords"
      :placeholder="template ? $t('Find template') : $t('Find requisition')" />

    <creating
      v-if="loading"
      height="50px" />

    <div
      class="list-group"
      v-if="!loading">
      <div
        class="list-group-item list-group-item-primary"
        v-if="selectedRequisition">
        <div class="d-flex">
          <div class="pr-3">
            <input
              type="checkbox"
              :checked="selectedRequisition"
              @input="setRequisition(null)">
          </div>
          <div class="w-100">
            <pointStatus
              v-if="showStatus"
              :status="selectedRequisition.status" />
            {{ selectedRequisition.title }}<br>
            <small>{{ subtitle(selectedRequisition) }}</small>
          </div>
        </div>
      </div>
      <a
        href="javascript:void(0)"
        class="list-group-item list-group-item-action"
        v-for="(requisition, index) in requisitions"
        :key="index"
        @click="setRequisition(requisition)">
        <pointStatus
          v-if="showStatus"
          :status="requisition.status" />
        {{ requisition.title }}<br>
        <small>{{ subtitle(requisition) }}</small>
        </a>
    </div>

  </div>

</template>

<script>
import InputKeyword from './InputKeyword'
import PointStatus from '@/components/Parts/PointStatus'

export default {
  name: 'SelectRequisition',
  components: {
    InputKeyword,
    PointStatus
  },
  props: {
    value: {
      type: String,
      default: null
    },
    disconsiderIds: {
      type: Array,
      default: () => { return [] }
    },
    limit: {
      type: Number,
      default: 3
    },
    template: {
      type: Boolean,
      default: false
    },
    showStatus: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      requisitions: [],
      keywords: ''
    }
  },
  watch: {
    keywords: function (val, oldVal) {
      if (val) {
        this.searchData({title: '~' + val})
      } else {
        this.requisitions = []
      }
    }
  },
  created () {
    if (this.value) this.loadData(this.value)
  },
  computed: {
    selectedRequisition () {
      return this.$store.getters['entities/requisitions/find'](this.value)
    }
  },
  methods: {
    subtitle (requisition) {
      return [requisition.company_id, requisition.departament_id]
        .filter((v) => { return v && v.name })
        .map((v) => { return v.name })
        .join(', ')
    },
    loadData (id) {
      this.loading = true

      this.$store
      .dispatch('getRequisitionById', id)
      .then((result) => {
        // this.selectedRequisition = result
        this.loading = false
      })
    },
    searchData (params) {
      this.loading = true

      const nParams = {
        ...params,
        template: this.template,
        limit: this.limit,
        sort: '-created_at'
      }

      if (this.disconsiderIds) {
        nParams['_id'] = this.disconsiderIds.map((v) => { return '!' + v })
      }

      this.$store
      .dispatch('getRequisitions', nParams)
      .then((result) => {
        this.requisitions = result.docs
        this.loading = false
      })
    },
    setRequisition (data) {
      this.$emit('input', data._id)
      this.$emit('object', data)
      this.keywords = ''
      this.requisitions = []
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectRequisition.vue